import { render } from "./proportionDetails.vue?vue&type=template&id=56993fa0&scoped=true"
import script from "./proportionDetails.vue?vue&type=script&lang=js"
export * from "./proportionDetails.vue?vue&type=script&lang=js"

import "./proportionDetails.vue?vue&type=style&index=0&id=56993fa0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56993fa0"]])

export default __exports__